import React from 'react';
import ReactTable from 'react-table';
import propTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { utcToPtDateString } from 'lib/date';

// have a mapper for the actions
const actionMap = {
  added: 'Created',
  published: 'Published',
  updated: 'Updated',
  unpublished: 'Unpublished',
  moved: 'Moved'
};
const TIME_FORMAT = 'YYYY-MM-DD HH:mm A';
const UNDEFINED_USER = 'undefined undefined';

/**
 * the history table
 * @param {object} history - history object
 * @returns {React.Component} component/page history
 */
const History = ({ history }) => {
  if (isEmpty(history)) {
    return <div>No Component History</div>;
  }

  const historyCopy = [...history];
  const reversedHistory = historyCopy.reverse();
  return (
    <ReactTable
      data={reversedHistory}
      columns={[
        {
          columns: [
            {
              Header: 'Time',
              id: 'TimeStamp',
              accessor: d => utcToPtDateString(d.TimeStamp, TIME_FORMAT),
              resizable: true
            },
            {
              Header: 'Status',
              id: 'Action',
              accessor: d => actionMap[d.Action],
              resizable: true
            },
            {
              Header: 'User',
              id: 'User',
              accessor: d => (d.User === UNDEFINED_USER ? 'Migrated' : d.User),
              resizable: true
            }
          ]
        }
      ]}
      defaultPageSize={5}
      previousText="Next History"
      nextText="Previous History"
      showPageSizeOptions={false}
    />
  );
};

History.propTypes = {
  history: propTypes.arrayOf(
    propTypes.shape({
      TimeStamp: propTypes.string.isRequired,
      Action: propTypes.string.isRequired,
      User: propTypes.string.isRequired
    })
  )
};
History.defaultProps = {
  history: null
};
export default History;
